import React from 'react'
import {useLocation} from 'react-router-dom'
import styled from 'styled-components'
import { TextContainer } from '../../styles/globalStyles';
import { useState,useEffect } from 'react';
import {LogOut as LogoutIcon} from '@styled-icons/boxicons-regular/LogOut'
import { useMsal } from "@azure/msal-react";
import {useDispatch} from 'react-redux';
import { useNavigate } from 'react-router-dom'
import { logOutUser } from '../../redux/feature/authSlice';
import { clearCart } from '../../redux/feature/cartSlice';
import { clearMenu } from '../../redux/feature/menuSlice';
import { clearVendorList } from '../../redux/feature/vendorSlice';
import SearchBar from '../SearchBar/Index';
import { clearOrderData } from '../../redux/feature/orderSlice';
import { useSelector } from 'react-redux';
import {b} from '../../styles/variables'
import { useMediaQuery } from '../../hooks/mediaquery';
import {Menu } from '@styled-icons/boxicons-regular/Menu'
import { sideBarOff, sideBarOn } from '../../redux/feature/uiSlice';
import {Wallet} from '@styled-icons/boxicons-regular/Wallet'

function Navbar() {
  const { instance} = useMsal();
  const dispatch=useDispatch();
  const cart = useSelector((state)=>state.cart)
  const auth = useSelector((state)=>state.auth)
  const location = useLocation()
  const path = location.pathname.split("/")

  useEffect(() => {    
    dispatch(sideBarOff())     
  },[location]);

  const [iconHoverState, setIconHoverState] = useState(false)
  let isMobileView = useMediaQuery(b.mobile)

  const pageTitle = path[1]==="" ? "Home" :
    path[1]==="cart" ? "My Cart" :
    path[1]==="liveorders" ? "All Orders" :
    path[1]==="finance" ? "Accounts" :
    path[1]==="myorders" ? "My Orders" :
    path[1]==="vendors" ? "Restaurants" :
    path[1]==="mylocation" ? "My Location" :
    path[1]==="analysis" ? "Accounts" :
    "Menu";
   
  return (
  <NavBody>
    {isMobileView ? 
      <Hamburger size={32} onClick={()=>{dispatch(sideBarOn())}}/> :
      <PageTitle>{pageTitle}</PageTitle>
    }

    <NavActions>
      {path[1]==='fooddata' && (
        <SearchWrapper>
          <SearchBar placeholder="Search food..."/>
        </SearchWrapper>
      )}

      <CreditsChip>
        <WalletIcon size={18} />
        <CreditsInfo>
          {!isMobileView && <GreetingText>Hi, {auth?.creds?.username?.split(' ')[0]}</GreetingText>}
          <CreditAmount>
            Balance: <strong>₹{Number(cart.cartTotalQuantity !== 0 ? cart?.userCredits : auth?.creds?.usercredit || 0).toFixed(2)}</strong>
          </CreditAmount>
        </CreditsInfo>
      </CreditsChip>

      <LogoutButton
        onClick={() => {
          dispatch(logOutUser())
          dispatch(clearCart())
          dispatch(clearMenu())
          dispatch(clearVendorList())
          dispatch(clearOrderData())
        }} 
        onMouseEnter={()=>setIconHoverState(true)} 
        onMouseLeave={()=>setIconHoverState(false)}
      >
        <LogoutIcon size={isMobileView ? 22 : 22} color={iconHoverState ? "#fff" : "#71717a"} />
      </LogoutButton>
    </NavActions>
  </NavBody>
  )
}

export default Navbar

const NavBody = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 0 2.4rem;
  height: 100%;
  overflow: hidden;

  @media ${b.mobile}{
    padding: 0 1.2rem;
    gap: 0.6rem;
  }
`

const PageTitle = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  color: #1e1e2d;
  white-space: nowrap;

  @media ${b.mobile}{
    display: none;
  }
`

const NavActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1.2rem;
  margin-left: auto;
  min-width: 0;
  flex-shrink: 1;

  @media ${b.mobile}{
    gap: 0.6rem;
    flex: 1;
    justify-content: flex-end;
  }
`

const SearchWrapper = styled.div`
  flex-shrink: 1;
  min-width: 0;

  @media ${b.mobile}{
    flex: 1;
    max-width: 160px;
  }
`

const CreditsChip = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f4f4f5;
  border: 1px solid #e4e4e7;
  border-radius: 12px;
  padding: 6px 14px;
  flex-shrink: 0;
  
  @media ${b.mobile}{
    padding: 4px 8px;
    gap: 4px;
  }
`

const WalletIcon = styled(Wallet)`
  color: #F7707D;
  flex-shrink: 0;
`

const CreditsInfo = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.3;
`

const GreetingText = styled.span`
  font-size: 1.1rem;
  color: #71717a;
  font-weight: 400;
`

const CreditAmount = styled.span`
  font-size: 1.2rem;
  color: #1e1e2d;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  strong {
    font-weight: 700;
    color: #22c55e;
  }

  @media ${b.mobile}{
    font-size: 1rem;
  }
`

const LogoutButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 10px;
  border: 1px solid #e4e4e7;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
  -webkit-tap-highlight-color: transparent;

  &:hover, &:active {
    background: #ef4444;
    border-color: #ef4444;
  }
`

const Hamburger = styled(Menu)`
  color: #1e1e2d;
  cursor: pointer;
  transition: color 0.2s ease;
  min-width: 44px;
  min-height: 44px;
  padding: 6px;

  &:hover, &:active {
    color: #F7707D;
  }
`
